import { createGenericApiSlice } from '../../../Api/Factory/genericApiFactory';
import { TagTypes } from '../../../Api/Types/tagTypes';
import { Contract, CreateContractCommand, UpdateContractCommand } from '../Types/contractsTypes';

export const contractsApi = createGenericApiSlice<
  Contract,
  CreateContractCommand,
  UpdateContractCommand,
  number,
  void
>({
  reducerPath: 'contractsApi',
  tag: TagTypes.Contract,
  endpoint: 'contract',
});

export const {
  useGetAllQuery: useGetContractsQuery,
  useGetByIdQuery: useGetContractByIdQuery,
  useCreateMutation: useCreateContractMutation,
  useUpdateMutation: useUpdateContractMutation,
  useDeleteMutation: useDeleteContractMutation,
} = contractsApi;
